import Glide from '@glidejs/glide';

new Glide('#testimonial-slide', {
  type: 'slider',
  perView: 1,
  dragDistance: true,
  dragThreshold: true,
  breakpoints: {
    1048: {
      perView: 1,
      dragDistance: true,
      dragThreshold: true,
    }
  },
}).mount();

new Glide('#slide-nossa-cultura', {
  type: 'slider',
  perView: 1,
  dragDistance: true,
  dragThreshold: true,
  breakpoints: {
    1048: {
      perView: 1,
      dragDistance: true,
      dragThreshold: true,
    }
  },
}).mount();

// Animação fade-in

window.addEventListener('scroll', function() {
  var items = document.querySelectorAll('.animacao-item');
  
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var itemTop = item.getBoundingClientRect().top;
    
    if (itemTop < window.innerHeight) {
      item.classList.add('show');
    }
  }
});


window.addEventListener('scroll', function() {
  var items = document.querySelectorAll('.animacao-item-trilha');
  
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var itemTop = item.getBoundingClientRect().top;
    
    if (itemTop < window.innerHeight) {
      item.classList.add('show');
    }
  }
});

window.addEventListener('scroll', function() {
  var items = document.querySelectorAll('.animacao-item-trilhas');
  
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var itemTop = item.getBoundingClientRect().top;
    
    if (itemTop < window.innerHeight) {
      item.classList.add('show');
    }
  }
});


// Animação troca de img
function initCrossfadeSlider() {
  let current = 0;
  let images = document.querySelectorAll('[data-crossfade-image]');

  setInterval(() => {
    images.forEach((image) => (image.style.opacity = 0));
    current = current != images.length - 1 ? current + 1 : 0;
    images[current].style.opacity = 1;
  }, 3000);
}

initCrossfadeSlider();


// Animação troca da cor do fill

var buttons = document.querySelectorAll('.my-button');
var paths = document.querySelectorAll('.my-svg path');

buttons.forEach(function(button) {
  button.addEventListener('click', function() {
    var color = this.dataset.color;
    paths.forEach(function(path) {
      path.style.fill = color;
    });
  });
});


// window.addEventListener("load", start)